import { PropTypes, Consts } from '../dependencies';

const DatePropType = PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]);

export const RangePropType = PropTypes.shape({
    from: DatePropType,
    to: DatePropType,
    relativePeriod: PropTypes.oneOf(Object.values(Consts.DateRanges)),
});
